module.exports = __webpack_public_path__ + "img/Copyright_pic07.cd5c7ea5.jpg";